import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from './context/AuthContext'
import AnimatedBackground from './components/ui/AnimatedBackground'
import TitleBar from './components/layout/TitleBar'

function App() {
  const [isElectron, setIsElectron] = React.useState(false);

  React.useEffect(() => {
    if (window.navigator.userAgent.includes('Electron')) {
      setIsElectron(true);
    }
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <TitleBar />
        <AnimatedBackground />
        <div className={isElectron ? "pt-10 min-h-screen w-full" : "min-h-screen w-full"}>
          <AppRoutes />
        </div>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
